import { Link } from "react-router-dom";

export function SiteHeader() {
  return (
    <header className="site-header">
      <Link
        className="site-header__brand"
        to="/"
        aria-label="性格劣化診断 ホーム"
      >
        <span aria-hidden="true" className="site-header__mark">
          PDC
        </span>
        <span>性格劣化診断</span>
      </Link>
      <nav aria-label="メインナビゲーション">
        <Link to="/about">診断について</Link>
        <Link to="/terms">注意事項</Link>
      </nav>
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <p className="site-footer__brand">PERSONALITY DECAY CHECK</p>
      <nav aria-label="フッターナビゲーション">
        <Link to="/privacy">プライバシー</Link>
        <Link to="/terms">利用上の注意</Link>
        <Link to="/about">この診断について</Link>
      </nav>
      <p className="site-footer__note">18歳以上対象 / 娯楽的セルフチェック</p>
    </footer>
  );
}
